import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancer-patients',
  templateUrl: './cancer-patients.component.html',
  styleUrls: ['./cancer-patients.component.css']
})
export class CancerPatientsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.documentElement.scrollTop = 0;
  }

}
